module.exports = __webpack_public_path__ + "img/wz-5-10.559c5498.png";